<template>
  <v-stepper 
    class="proceso-pago elevation-0"
    :value="step"
    :alt-labels="!$vuetify.breakpoint.mdAndDown"
    :vertical="$vuetify.breakpoint.mdAndDown"
  >
    <component 
      v-if="modulosStepper.length > 1"
      :is="!$vuetify.breakpoint.mdAndDown ? 'v-stepper-header' : 'v-flex'"
      class="elevation-0"
      :class="$vuetify.breakpoint.mdAndDown ? 'proceso-pago-header' : ''"
    >
      <template
        v-for="(item, index) in modulosStepper"
      >
        <v-stepper-step 
          :key="'step' + item.tipo"
          :complete="item.tipo === 'resumen' || item.tipo === 'condiciones' || moduloTerminado(item.tipo, reserva) || (item.tipo === 'kyc' && getModuloCodigo('kyc', reserva) === 3)"
          :step="index + 1"
          :color="item.tipo === 'resumen' && step != modulosStepper.length ? 'grey' : 'primary'"
        >
          <span 
            class="textoAjustado"
            :class="{
              'text-xs-center' : !$vuetify.breakpoint.mdAndDown,
              'grey--text': item.tipo === 'resumen' || step != index + 1
            }"
          >
            {{getNombreModulo(item.tipo)}}
          </span>
        </v-stepper-step>
        <v-divider :key="'divider' + item.tipo" v-if="index + 1 < modulosStepper.length" :vertical="$vuetify.breakpoint.mdAndDown"/>
      </template>
    </component>
  </v-stepper>
</template>
<script>
import modulos from '@/mixins/modulos'
export default {
  props: {
    tipoModuloActual: {
      type: String,
      required: true
    }
  },
  mixins: [modulos],
  computed: {
    step () {
      return this.modulosStepper.findIndex(x => x.tipo === this.tipoModuloActual) + 1
    },
    modulosStepper () {
      let retorno = this.modulos.concat(
        {
          nombre: this.$t('pages.incrustado.procesoFinalizado'),
          tipo: 'resumen'
        }
      )
      // Quitar paso pago si no hay importe
      if (this.reserva != null && this.reserva.importeReserva === 0) {
        retorno = retorno.filter(x => (x.tipo !== 'pago'))
      }
      return retorno
    }
  },
  methods: {
    getNombreModulo(tipo) {
      if (tipo === 'resumen') {
        return this.$t('pages.incrustado.procesoFinalizado')
      }
      return this.getTexto('modulos.' + tipo + (this.reserva.cod_tipo_operacion !== 'VTA' ? 'Alquiler' : ''))
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/StepperPortal.vue